import actionTypes from '../constants/action-types';

const updateRedirects = (redirects) => ({
  type: actionTypes.UPDATE_REDIRECTS,
  payload: {
    redirects,
  },
});

export default updateRedirects;
